// extracted by mini-css-extract-plugin
export default {"IsDragging":"DraggableTimeslotWrapper_IsDragging__0XUSq","Item":"DraggableTimeslotWrapper_Item__sPwli"};